const REGEX_ONLY_LETTERS = new RegExp(/[^a-zA-ZÀ-ÿ\u00f1\u00d1 ]*/g);
const REGEX_ONLY_LETTERS_AND_NUMBERS = new RegExp(/[^a-zA-ZÀ-ÿ0-9\u00f1\u00d1 ]*/g);
const REGEX_WITHOUT_AMPERSAND = new RegExp(/[&]+/g);

export function parseOnlyLetter(value: string): string {
  return value ? value.replace(REGEX_ONLY_LETTERS, '') : '';
}

export function parseOnlyLetterAndNumber(value: string): string {
  return value ? value.replace(REGEX_ONLY_LETTERS_AND_NUMBERS, '') : '';
}

export function removeAmpersand(value: string): string {
  return value ? value.replace(REGEX_WITHOUT_AMPERSAND, '') : '';
}
